export function MailMe() {
    window.open('mailto: qawitherev@gmail.com', 'blank')
}